import type { UseQueryResult } from "@tanstack/react-query"
import { useQuery } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import type { BatteryProposalFinancingDto } from "../dto/battery-proposal.dto"
import { batteryProposalService } from "../services/battery-proposal.service"

export default function useBatteryProposalFinancing(
  proposalId: string | undefined,
  { enabled = true }: { enabled?: boolean } = {},
): UseQueryResult<BatteryProposalFinancingDto> {
  return useQuery({
    queryKey: queryKeys.batteryProposal.financing(proposalId ?? ``),
    queryFn: () => {
      if (!proposalId) {
        throw new Error(`Battery-Only Proposal id is required`)
      }

      return batteryProposalService.getFinancing(proposalId)
    },
    enabled: Boolean(proposalId) && enabled,
    retry: 1,
    refetchOnWindowFocus: false,
  })
}
